import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateExtraQuantity } from '../store/slices/cartSlice';

const CartItemEditModal = ({ item, onClose }) => {
  const dispatch = useDispatch();
  const [editedExtras, setEditedExtras] = useState(() => {
    const paidExtras = {};
    if (item.extras) {
      Object.entries(item.extras).forEach(([category, extras]) => {
        const paidCategoryExtras = extras.filter(extra => extra.price > 0);
        if (paidCategoryExtras.length > 0) {
          paidExtras[category] = paidCategoryExtras;
        }
      });
    }
    return paidExtras;
  });

  useEffect(() => {
    const hasActiveExtras = Object.values(editedExtras).some(categoryExtras => 
      categoryExtras.some(extra => extra.quantity > 0)
    );
    
    if (!hasActiveExtras) {
      onClose();
    }
  }, [editedExtras, onClose]);

  const handleExtraQuantityChange = (category, extraName, newQuantity) => {
    const quantity = Math.max(0, newQuantity);
  
    setEditedExtras(prev => {
      const updatedExtras = quantity === 0
        ? {
            ...prev,
            [category]: prev[category].filter(extra => extra.name !== extraName)
          }
        : {
            ...prev,
            [category]: prev[category].map(extra =>
              extra.name === extraName
                ? { ...extra, quantity }
                : extra
            )
          };
  
      if (updatedExtras[category].length === 0) {
        delete updatedExtras[category];
      }
  
      return updatedExtras;
    });
  
    dispatch(updateExtraQuantity({
      id: item.id,
      category,
      extraName,
      quantity
    }));
  };

  if (Object.keys(editedExtras).length === 0) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center">
      <div className="bg-black p-6 rounded-lg w-96 border border-red-500">
        <h2 className="text-2xl mb-4 text-red-500">Edit {item.name}</h2>
        
        {Object.entries(editedExtras).map(([category, extras]) => (
          <div key={category} className="mb-4">
            <h3 className="font-semibold capitalize text-red-500">{category}</h3>
            {extras.map((extra, index) => (
              <div key={index} className="flex justify-between items-center mb-2">
                <span className="text-white">{extra.name} (₦{extra.price.toLocaleString()})</span>
                <div className="flex items-center">
                  <button 
                    onClick={() => handleExtraQuantityChange(
                      category, 
                      extra.name, 
                      (extra.quantity || 0) - 1
                    )}
                    className="px-2 bg-gray-800 text-white rounded-l"
                  >
                    -
                  </button>
                  <span className="px-4 bg-gray-900 text-white">{extra.quantity || 0}</span>
                  <button 
                    onClick={() => handleExtraQuantityChange(
                      category, 
                      extra.name, 
                      (extra.quantity || 0) + 1
                    )}
                    className="px-2 bg-gray-800 text-white rounded-r"
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
          </div>
        ))}
        
        <div className="flex justify-end space-x-2 mt-4">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartItemEditModal;